import React from "react";
import ReactDOM from "react-dom/client";
import "isomorphic-fetch";

import "./i18n";
import reportWebVitals from "./reportWebVitals";
import App from "./components/app";
import "index.css";

// Locate the data-itinerary-id element
const element = document.querySelector(
  "#alpacaNRMAMemberBenefitsAmpol"
) as HTMLElement;
if (element == null) {
  console.error(
    "Unable to locate the element with ID #alpacaNRMAMemberBenefitsAmpol"
  );
} else {
  // We want to have our application displayed using flex layout
  element.style.display = "flex";

  // Build our root react element
  const root = ReactDOM.createRoot(element);

  // Any customisable data for the application
  const ampolServiceDataUri =
    element.dataset.ampolServiceDataUri ||
    "//cdn.alpacamaps.com/nrma/ampol-member-benefits/data.json";
  if (typeof ampolServiceDataUri != "string") {
    console.log("Please specify the data-ampol-service-data-uri attribute");
  }

  if (typeof ampolServiceDataUri === "string") {
    root.render(<App ampolServiceDataUri={ampolServiceDataUri} />);
  }

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
